export enum ApiRoutesSharing {
  SharingSchedules = "admin/product-sharings/schedules",
  ProductSharings = "admin/product-sharings",
  SharingSchedulesSettings = "admin/product-sharings/schedules/settings",
  SharingsSectionStyle = "public/product-sharings/products-to-share/settings"
}

export enum SharingSchedulesSettingsMode {
  CustomSchedules = "CustomSchedules",
  Random = "Random"
}

export enum SharingScheduleRules {
  BestSellingProducts = "BestSellingProducts",
  ManualSelectionOfProducts = "ManualSelectionOfProducts",
  ProductsLessThanTenInStock = "ProductsLessThanTenInStock",
  MostSharedProducts = "MostSharedProducts",
  HighlyRatedProducts = "HighlyRatedProducts",
  MostWishedProducts = "MostWishedProducts",
  MostSearchedProducts = "MostSearchedProducts",
  ProductsThatExperiencedSuddenIncreaseInSales = "ProductsThatExperiencedSuddenIncreaseInSales",
  PopularProductsThatWereRestocked = "PopularProductsThatWereRestocked",
  HighCartAbandonmentRate = "HighCartAbandonmentRate"
}

export enum SharingScheduleRuleTimeFrames {
  ForAllTime = "ForAllTime",
  OverPastDay = "OverPastDay",
  OverPastWeek = "OverPastWeek",
  OverPastMonth = "OverPastMonth",
  OverPastYear = "OverPastYear"
}

export enum SharingSocials {
  WhatsApp = "WhatsApp",
  Instagram = "Instagram",
  Twitter = "Twitter",
  Facebook = "Facebook",
  TikTok = "TikTok",
  Snapchat = "Snapchat",
  Telegram = "Telegram"
}
